var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "url(#pattern0_1_3509)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1_3509",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_3509",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_3509",
    width: 24,
    height: 24,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYEAYAAACw5+G7AAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAAGYktHRAAAAAAAAPlDu38AAAAJcEhZcwAAAGAAAABgAPBrQs8AAAAHdElNRQfnBgsLMgkHLfAPAAAEM0lEQVRYw+1WbUybVRR+TikC2pEZYJaFzCWM4ojS4cYyDFvKhySgUojDNR1kzAXQ2nb8GJlAMEMymBlkSoEBC84Moi7CpNMMM2yAaBacTqygwKA/+BBWgYQsCANKjz/krWSIHYLZj/H8e8/HPc+55773PsAGNvBog+435LKBlaxQ2H8hCX+Sng4R/0itPj4rLjCCTM7v7i6M1jVd9dXrc6INWxPCCwu5FC0cFBq6ZoZ2ep4VY2Pwsu93+bCqqshX/9XnX7e1CW7x/cT5OJp5wmQiCZ+hyyIRgOv/WqAZH9NtiQTAkwBAv3I7nwoJQR0ZYYiOXvse8xm6DGCKAhc+PXQoe7QUiarISKERkSOsFjvRlJEBCXrpmEi0hor/DwReE6JvFl7PyBDMfzeQhBikSKUPm6dT+PMx0vn6Cp9ipwm5KIWSme/SAOWVl+M5NHNWUxMFcg/3BgSghGLofHg4DizG36HN8BwaQhse462ZmdxLz1BgXx8184tAXBxkeBqeGg1OQw8jkdP6TuBogIrpCpfcusXJbKIbNpvDnoorqL92regzbV/jb+fOnew0xCf6y+XTQxx2r8xkwhR7AZWVjgUXxjdNhmo0wPZ0hIrF88dnojx/l8kKQzRzXzyl1eYkGfyUcRYL5yMGfnFxqyVMxfQel5jNAIDUf7iFVkKOviLyFWtwMCQLiaJ0s5mKEY+wjg7x7Pi2yZN79+ZTPrWRzZaeVlWZnubq6u0xV2ptu3kTEryJnbt2uTQgCUnBwQW9OqkxubNzrTu/bAI5BWV+8R8VF/OrbKIbcrlgF73Ffvyz0Sj+wPp4yJaKirmj3paf/LOyEAs3+CkUNr1XrGfTnj1/Rbe3+7jPNo4m7t7N79MOihoeRiarRLl1dQW9Ou9GY1dXbgT/Eb9Pq7WX0zAFK5WrnkADRfELZnNhnnb4auqJE44JZM8Y9EqvlhYqQADCFQpHRjI88OzsLCa5ngc1mvGLbglS99ra6gsZb1RfmJ93VtAxkaOzjXfupaRgMx2kbRUVqMMMutzcVtsA56EP37a2FnnoSo0TERHOr0uh0Jf0Et2tqfGpmfvBmjY4mB1ZFprQLZOtlCb4hXgh/78SXwkPft9bocQBm438APt3hw/3e23Jcn3HYsnZbphW3tbplhKPDzhyRPAL8UL+ehFfdQN0Ee9i//j4vMpez2H9/QHh1utz31+6BB/MYlStdizYY2+g8yqV4J9zx8sU0tODJ0iG7LGx9W7A+TuwCH4bcpyWSl0gkrtgYABWAI5fvb19WYIVcsjVavFBDNFZtRrgs4hdb/pLJ2ChGjaMjq5/ifUFVWMam0ZGljewqPYwhUCusdsfNtFlWOTFr/GwaEd1tWB2HCFB3QlqzyGanMnpSKhZ1t2NRd3JQbSPTnV0cDJaOEj8wEd0RSyV06rlcnoDG3jU8SeFhtPy/i+IPgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.7539c8c0bef909e7093ddc55adde6437.svg";
export { ForwardRef as ReactComponent };